export default {
  back: {
    en: 'Back',
  },
  next: {
    en: 'Next',
  },
  choose: {
    en: 'Choose',
  },
  accept: {
    en: 'Accept',
  },
  cancel: {
    en: 'Cancel',
  },
  confirm: {
    en: 'Confirm',
  },
  decline: {
    en: 'Decline',
  },
  login: {
    en: 'Login',
  },
  finish: {
    en: 'Finish',
  },
  reject: {
    en: 'Reject',
  },
  save: {
    en: 'Save',
  },
  submit: {
    en: 'Submit',
  },
  subscribe: {
    en: 'Subscribe',
  },
  subscribeNow: {
    en: 'Subscribe now',
  },
  resubscribe: {
    en: 'Resubscribe',
  },
  unsubscribe: {
    en: 'Unsubscribe',
  },
  upgrade: {
    en: 'Upgrade',
  },
  close: {
    en: 'Close',
  },
  orderNow: {
    en: 'Order now',
  },
  shopNow: {
    en: 'Shop now',
  },
  buyNow: {
    en: 'Buy now',
  },
  gotIt: {
    en: 'Got it!',
  },
  redeem: {
    en: 'Redeem',
  },
  discoverNow: {
    en: 'Discover now',
  },
  chooseNow: {
    en: 'Choose now',
  },
  getStarted: {
    en: 'Get started',
    es: 'Comienza ahora',
  },
  getTheOffer: {
    en: 'Get the offer',
  },
  signMeUp: {
    en: 'Sign me up',
  },
  joinToday: {
    en: 'Join today',
  },
  resetPassword: {
    en: 'Reset password',
  },
  update: {
    en: 'update',
  },
  continue: {
    en: 'continue',
  },
  neverMind: {
    en: 'Never mind',
  },
  send: {
    en: 'Send',
  },
  imIn: {
    en: 'i\'m in',
  },
  checkout: {
    en: 'Checkout',
  },
  buyInOneClick: {
    en: 'Buy in one click',
  },
  learnMore: {
    en: 'Learn more',
  },
  upgradeMe: {
    en: 'Upgrade me',
  },
}
